import { KGPortalUser } from '~/Types/User.type';

export const getUserWithLocation = (data: KGPortalUser) => ({
  employeeEmail: data?.email ?? '',
  employeeLocation: data?.office?.Name ?? '',
});
